// 1. React imports
import { useId } from 'react';

// 3. Internal components
import { Checkbox } from '~/components/ui/checkbox';
import { Field, FieldLabel } from '~/components/ui/field';

interface CheckboxWithLinkProps {
  /** Whether the checkbox is checked */
  checked: boolean;
  /** Callback when checkbox state changes */
  onChange: (checked: boolean) => void;
  /** Label text shown before the link */
  label: string;
  /** URL for the link */
  href: string;
  /** Text displayed for the link */
  linkText: string;
  /** Whether the checkbox is disabled */
  disabled?: boolean;
}

/**
 * Checkbox with inline label containing a link.
 * Link opens in new tab with security attributes.
 * Per §TS.3.1: Function declaration for named export.
 */
export function CheckboxWithLink({
  checked,
  onChange,
  label,
  href,
  linkText,
  disabled = false,
}: CheckboxWithLinkProps) {
  const id = useId();

  return (
    <Field orientation="horizontal">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(value) => onChange(value === true)}
        disabled={disabled}
      />
      <FieldLabel htmlFor={id} className="font-normal">
        <span>
          {label}{' '}
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => event.stopPropagation()}
            className="text-primary underline underline-offset-4 hover:text-primary/80"
          >
            {linkText}
          </a>
        </span>
      </FieldLabel>
    </Field>
  );
}
